import React from "react";
import DraggableBox from "../../layouts/dashboard/CallingBox/DraggableBox";
import ComponentPopup from "../GeneralComponents/ComponentPopup";
import StudentOffline from "../Chatting/StudentOffline";

export default function ClassRoomProviderChildern(props) {
  const {
    isDisconnecting,
    isPeerReconnecting,
    updateState,
    isUnavailable,
    callUser,
  } = props;
  return (
    <>
      {callUser && <DraggableBox />}
      {isDisconnecting && (
        <div className="is-disconnecting-call">
          <div className="disconnecting-text">
            <h2>Connection with the student has been lost.</h2>
            <h2> Waiting to reconnect...</h2>
          </div>
        </div>
      )}
      {!isDisconnecting && isPeerReconnecting && !callUser && (
        <div className="is-disconnecting-call peer-signaling-reconnect">
          <div className="disconnecting-text">
            <h2>Call service reconnecting...</h2>
          </div>
        </div>
      )}
      <ComponentPopup
        openPopup={isUnavailable}
        setOpenPopup={(value) => updateState({ isUnavailable: value })}
        title=""
        paperClass="student-offline-modal"
        componentToPassDown={
          <StudentOffline
            handleClose={() => updateState({ isUnavailable: false })}
          />
        }
      />
    </>
  );
}
